import { render, staticRenderFns } from "./TeamCrestManager.vue?vue&type=template&id=51754576&scoped=true"
import script from "./TeamCrestManager.vue?vue&type=script&lang=js"
export * from "./TeamCrestManager.vue?vue&type=script&lang=js"
import style0 from "./TeamCrestManager.vue?vue&type=style&index=0&id=51754576&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51754576",
  null
  
)

export default component.exports